import Vue from 'vue'
import App from './App'
import router from './router'
//引入reset css
import '@/assets/styles/reset.css';
//引入svg图标
import '@/assets/icons'
import '@/router/permission'
//Element UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
//生产环境下是否显示提示——tip
Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js